export enum Types {
	CADASTRA_DOCUMENTOS_REQUEST = '@iirgd/CADASTRA_DOCUMENTOS_REQUEST',
	CADASTRA_DOCUMENTOS_SUCCESS = '@iirgd/CADASTRA_DOCUMENTOS_SUCCESS',
	CADASTRA_DOCUMENTOS_FAILURE = '@iirgd/CADASTRA_DOCUMENTOS_FAILURE',
	LIMPA_CADASTRA_DOCUMENTOS = '@iirgd/LIMPA_CADASTRA_DOCUMENTOS',
}

export interface CadastraDocumentos {
	status: number;
}

export interface CadastraDocumentosRequest {
	rg: string;
	cpf: string;
	urlArquivo: string;
}
